
const digest = '0771a118fa2730ec6bfe2ab5af946b532aa9be1f4e5afda5b98054a40b793ee4';
const classes = {"wrapper":"_wrapper_6fk0s_1","borderActive":"_borderActive_6fk0s_10","video":"_video_6fk0s_14","title":"_title_6fk0s_20","checkbox":"_checkbox_6fk0s_27","active":"_active_6fk0s_36","send":"_send_6fk0s_41","pdfLink":"_pdfLink_6fk0s_47","thumbnail":"_thumbnail_6fk0s_51"};
const css = `._wrapper_6fk0s_1 {
  font-family: Rubik, sans-serif;
  border: 2px solid #e2e5ed;
  padding: 10px;
  border-radius: 15px;
  margin-bottom: 10px;
  height: 100%;
}

._borderActive_6fk0s_10 {
  border-color: #1d65d8;
}

._video_6fk0s_14 {
  width: 100%;
  height: 200px;
  background-color: coral;
}

._title_6fk0s_20 {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  margin-top: 5px;
}

._checkbox_6fk0s_27 {
  width: 25px;
  height: 25px;
  background: url("/dist/icons/react/fakebox.svg") no-repeat center;
  background-size: contain;
  margin-bottom: 10px;
  cursor: pointer;
}

._active_6fk0s_36 {
  background: url("/dist/icons/react/fakebox-checked.svg") no-repeat center;
  background-size: contain;
}

._send_6fk0s_41 {
  font-size: 14px;
  font-weight: 600;
  color: #419a0d;
}

._pdfLink_6fk0s_47 {
  cursor: pointer;
}

._thumbnail_6fk0s_51 {
  width: 100%;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  